// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment/types';

export function speiOutgoingPaymentMapper(): $Shape<OutgoingPayment> {

  return {
    payment_type: 'spei',
    payment_type_code: 'spei',
    instalments: '1',
  };
}
